import { request } from '@umijs/max';
import { ApiAuthAccount, LoginParams, LoginResultData } from '../ApiTypings';

export namespace ApiPassport {
  /**
   * @summary 登录
   * @secure
   */
  export const login = async (data: LoginParams, params: { [key: string]: any } = {}) => {
    return request<LoginResultData>(`/api/passport/login`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 注销登录
   * @secure
   */
  export const logout = async (params: { [key: string]: any } = {}) => {
    return request<boolean>(`/api/passport/logout`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取登录信息
   * @secure
   */
  export const auth = async (params: { [key: string]: any } = {}) => {
    return request<ApiAuthAccount>(`/api/passport/auth`, {
      method: 'GET',
      ...params,
    });
  };
}

export default ApiPassport;

export const login = ApiPassport.login;
export const logout = ApiPassport.logout;
export const auth = ApiPassport.auth;
